// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getCustomerSalesperson } from "@awc/App/Services/SalesPersonService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

interface GetCustomerSalespersonParameter {
    getSalesPersonPicks: boolean;
    onSuccess?: (props: any) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<GetCustomerSalespersonParameter, any>;

export const PopulateApiParameter: HandlerType = (props: any) => {
    props.apiParameter = { GetSalesPersonPicks: props.parameter.getSalesPersonPicks };
};

export const RequestDataFromApi: HandlerType = async (props: any) => {
    props.apiResult = await getCustomerSalesperson(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = (props: any) => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

const loadCustomerSalesPerson = createHandlerChainRunner(
    [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback],
    "loadCustomerSalesPerson",
);

export { loadCustomerSalesPerson };
